module.exports = __webpack_public_path__ + "img/title-5.9ff2fd9c.png";